module.exports = __webpack_public_path__ + "static/img/son11.1e5ea4f0.jpg";